import type { RequestConfig } from "@app/config/axios/http";
import { enterpriseApi } from "./api.core";
import type { Enterprise, EnterpriseFilter } from "./types";

/** Сервисный слой — предприятия. */
export const enterpriseServices = {
    ...enterpriseApi,

    /**
     * Загружает предприятия по фильтру.
     * @param params фильтр предприятий
     * @param config опции HTTP-запроса
     */
    load: async (
        params: {
            flt?: EnterpriseFilter;
        },
        config?: RequestConfig,
    ): Promise<Enterprise[]> => {
        return enterpriseApi.load(params, config);
    },
} as const;
